"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgPriceAlert1(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 73
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "M0 25.99l39.484 4.76 39.184-15.368 39.716 5.789 39-20.171 50.562 71.132"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166 19)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A2E9C6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#17181A",
    transform: "rotate(10 -35.144 69.307)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.436 2.25c-2.68.164-4.098 1.746-4.257 4.745-.159 2.999-1.05 4.832-2.673 5.5-.605.562-.605 1.024 0 1.386.908.543 3.604 1.176 6.93 1.176h.07c3.326 0 6.022-.633 6.93-1.176.605-.362.605-.824 0-1.387-1.623-.667-2.514-2.5-2.673-5.5-.16-2.998-1.578-4.58-4.257-4.745h-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.04 15.011a2.932 2.932 0 00-.076.707 2.482 2.482 0 104.963 0 2.91 2.91 0 00-.104-.739c-.755.082-1.547.123-2.378.123-.83 0-1.632-.03-2.405-.09z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.445,
    cy: 0.827,
    r: 1
  })))));
}

var MemoSvgPriceAlert1 = /*#__PURE__*/React.memo(SvgPriceAlert1);
var _default = MemoSvgPriceAlert1;
exports["default"] = _default;